import authority from './authority'
import config from './config'
import depart from './depart'
import files from './files'
import combined from './combined'


const data = [...authority, ...config, ...depart, ...files, ...combined]

export default data